import type { FunctionComponent, PropsWithChildren } from "react"

import { Link } from "@/modules/routing/components/Link"

type PaginationLinkProps = {
  href: string
  className: string
  onClick: () => void
}

export const PaginationLink: FunctionComponent<PropsWithChildren<PaginationLinkProps>> = ({
  href,
  className,
  onClick,
  children,
  ...props
}) => (
  <Link {...props} className={className} href={href} scroll={false} shallow onClick={onClick}>
    {children}
  </Link>
)
